import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shield, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      // verify admin role
      await api.get("/admin/me");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Sign in failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--background))] grid place-items-center p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6" data-testid="admin-login-form">
        <div className="flex items-center gap-2"><Shield size={16} className="text-[hsl(var(--accent))]" /><span className="font-display font-semibold">GatherVoices Admin</span></div>
        <p className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">Platform team only. This page is never linked from the public site.</p>
        <label className="mt-5 block text-xs font-semibold uppercase tracking-wide text-[hsl(var(--muted-foreground))]">Email</label>
        <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 w-full h-11 rounded-xl px-3 bg-[hsl(var(--background))] border border-[hsl(var(--input))] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]" />
        <label className="mt-4 block text-xs font-semibold uppercase tracking-wide text-[hsl(var(--muted-foreground))]">Password</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 w-full h-11 rounded-xl px-3 bg-[hsl(var(--background))] border border-[hsl(var(--input))] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]" />
        <button data-testid="admin-submit" disabled={loading} className="mt-5 w-full h-11 rounded-xl bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-semibold text-sm disabled:opacity-60 inline-flex items-center justify-center gap-1.5">
          {loading ? <Loader2 size={14} className="animate-spin" /> : null} Sign in
        </button>
      </form>
    </div>
  );
}
